import styled from "@emotion/styled";
import { FormControl } from "@mui/material";

export const StyledFormControl = styled(FormControl)(
  ({ width, height, border, background, padding }) => ({
    borderRadius: "0.5rem",
    width: `${width}`,
    height: `${height}`,
    border: `${border}`,
    background: `${background}`,
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "transparent",
      },
      "&:hover fieldset": {
        borderColor: "transparent",
      },
      "&.Mui-focused fieldset": {
        borderColor: "transparent",
      },
    },
    "& .MuiOutlinedInput-input": {
      display: "flex",
      alignItems: "center",
      padding: `${padding ? padding : "4px"}`,
      color: "#6A6A6A",
      background: "transparent",
    }
  })
);
